const theme = {
  LIGHT: {
    dark: false,
    //if this 'variables' property is used, things go nuts. we just override the theme colors for now
    variables: {},
    colors: {
      primary: '#1F3C73',
        // if you add any other shade back in, be sure to also add it in AppStore.js for the corresponding color
      'primary-lighten-3': '#3c79b6',
      'primary-lighten-5': '#5796cb',
      'primary-lighten-9': '#e3eff7',
      banner: '#1F3C73',
      secondary: '#F6F7F8',
      accent: '#3c79b6',
      error: '#B4221F',
      'error-lighten-1': '#D03331',
      'error-lighten-2': '#EC5552',
      'error-lighten-3': '#ED9B9B',
      'error-lighten-4': '#FECDD2',
      warning:'#FB8C00',
      success: '#1B5E20',
      'success-lighten-1': '#388E3B',
      'success-lighten-2': '#66BB6A',
      'success-lighten-3': '#A5D6A7',
      'success-lighten-4': '#E8F5E9',
      active:'#e3eff7',
      anchor: '#2c5893',
      grey: '#9E9E9E',
      'grey-lighten-1': '#BDBDBD',
      'grey-lighten-2': '#E0E0E0',
      'grey-lighten-3': '#EEEEEE',
      'grey-lighten-4': '#F5F5F5',
      'grey-darken-1': '#757575',
      'grey-darken-2': '#616161',
      'grey-darken-3': '#424242',
      'grey-darken-4': '#212121',
      highlight: '#FFF384',
      surface: '#FFFFFF',
      'on-primary': '#FFFFFF',
      'on-primary-lighten-3': '#FFFFFF',
      'on-primary-lighten-5': '#FFFFFF',
      //surface variants for light theme
      'surface-bright': '#FFFFFF',
      'surface-light': '#EEEEEE',
      'surface-variant': '#424242',
      'on-surface-variant': '#EEEEEE',
      'on-surface-bright': '#000000',
      'on-surface-light': '#000000',
      'error-base': '#b4221f'
    }
  }
}

export default theme
